module.exports = __webpack_public_path__ + "Roboto-Thin.94998475f6aea65f5584.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Thin.ttf
// module id = ../../../../../src/font/roboto/Roboto-Thin.ttf
// module chunks = 1